import * as React from 'react';
import { JRCFormSelectTagField } from '../JRCFormSelect/JRCFormSelectTag';
import jamespot from 'jamespot-user-api';
import { JRCFormSelectProps } from '../JRCFormSelect/JRCFormSelect';

const autocompleteCommunity = (inputValue: string) => jamespot.community.autocomplete(inputValue);

/**
 * Component audience that returns community input according to the user input
 * @param props JRCWritableFormInputProps
 * validation props: required
 * @returns JSX.Element
 * @deprecated use JRCInputAutocomplete and its variants instead
 */
const JRCFormAutocompleteCommunityField = (props: JRCFormSelectProps<any>) => {
    return (
        <JRCFormSelectTagField
            getOptionValue={(v: any) => v.uri}
            getOptionLabel={(v: any) => v.name}
            asyncPromise={(inputValue: string) => autocompleteCommunity(inputValue)}
            {...props}
        />
    );
};

export { JRCFormAutocompleteCommunityField };
